import { render, staticRenderFns } from "./sort-list.vue?vue&type=template&id=5d6acde3&"
import script from "./sort-list.vue?vue&type=script&lang=ts&"
export * from "./sort-list.vue?vue&type=script&lang=ts&"
import style0 from "./sort-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports